var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import libraryHelpers from "../helpers/libraryFilters";

function getPropertyText(prop, values) {
  const options = values.map((value) => prop.options.find((o) => o.id === value));
  const labels = options.map((o) => o && o.label).filter((l) => l);
  return labels.join(', ');
}

function getPropertiesTexts(query, properties) {
  return Object.keys(query.filters).reduce((descriptions, propName) => {
    const { values } = query.filters[propName];
    const property = properties.find((p) => p.name === propName);
    if (!values || !property) {
      return descriptions;
    }
    const propText = `${property.label}: ${getPropertyText(property, values)}`;
    return [...descriptions, propText];
  }, []);
}

export class SearchDescription extends Component {
  render() {
    const { searchTerm, query, properties } = this.props;
    const descriptions = query && query.filters ? getPropertiesTexts(query, properties) : [];
    const descriptionText = descriptions.length ? ` ${descriptions.join(' - ')}` : '';
    return /*#__PURE__*/(
      _jsx("span", {}, void 0,
      searchTerm,
      descriptionText));


  }
}

SearchDescription.defaultProps = {
  query: undefined
};







export function mapStateToProps({ templates, relationTypes }, { query }) {
  const properties =
  query && query.filters ?
  libraryHelpers.URLQueryToState(query, templates.toJS(), relationTypes.toJS()).properties :
  [];
  return {
    properties
  };
}

export default connect(mapStateToProps)(SearchDescription);